export interface Category {
  id: number;
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 1,
    slug: 'zuixin-baoliao',
    name: '最新爆料',
    description: '第一时间掌握各类独家爆料信息，了解事件真相与内幕细节',
    icon: 'ri-flashlight-line',
    articleCount: 128,
  },
  {
    id: 2,
    slug: 'shehui-redian',
    name: '社会热点',
    description: '聚焦社会民生热点话题，深入解读事件背后的真相与影响',
    icon: 'ri-fire-line',
    articleCount: 256,
  },
  {
    id: 3,
    slug: 'yule-bagua',
    name: '娱乐八卦',
    description: '娱乐圈最新动态与明星八卦，揭开光环背后的真实故事',
    icon: 'ri-star-line',
    articleCount: 189,
  },
  {
    id: 4,
    slug: 'hangye-jiemi',
    name: '行业揭秘',
    description: '深度剖析各行业内幕与潜规则，揭示不为人知的商业真相',
    icon: 'ri-building-line',
    articleCount: 94,
  },
  {
    id: 5,
    slug: 'shendu-diaocha',
    name: '深度调查',
    description: '专业团队深入一线调查报道，还原事件全貌与来龙去脉',
    icon: 'ri-search-eye-line',
    articleCount: 67,
  },
  {
    id: 6,
    slug: 'wangyou-tougao',
    name: '网友投稿',
    description: '社区用户自发分享的真实经历与见闻，汇聚民间智慧与声音',
    icon: 'ri-user-voice-line',
    articleCount: 312,
  },
];